/*
 * @Author: Kuiper
 * @Date: 2021-08-20 18:14:29
 */
import { App } from 'vue'
import { Router } from 'vue-router'
import * as Sentry from '@sentry/vue'
import { Integrations } from '@sentry/tracing'
import pkg from '../../../package.json'

export function setupErrorHandle(app: App, router: Router) {
  if (import.meta.env.VITE_USE_SENTRY === 'false') return

  Sentry.init({
    app,
    dsn: 'https://689527d13092413eb47355a54615768f@o967152.ingest.sentry.io/5958016',
    release: `${pkg.name}@${pkg.version}`,
    integrations: [
      new Integrations.BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracingOrigins: ['ccss.tv', 'v.ccss.tv', 'beta-webapp.skysrt.com', /^\//],
      }),
    ],
    environment: process.env.NODE_ENV,
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
  })

  app.provide('$sentry', Sentry)
  // app.config.globalProperties.$sentry = Sentry
}

////////////////使用//////////////
// const $sentry: any = inject('$sentry')
// setTimeout(() => {
//   $sentry && $sentry.captureException(new Error('第5个错误'))
// }, 5000)
